var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationHilightLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.735 7.40001C15.1232 7.79093 15.1224 8.42256 14.7329 8.81211L11.5638 11.9812C11.1736 12.3714 11.1733 13.004 11.5631 13.3946L14.7337 16.5721C15.1225 16.9618 15.1222 17.5928 14.7329 17.9821V17.9821C14.3433 18.3717 13.7117 18.3717 13.3221 17.9821L8.73461 13.3946C8.34408 13.0041 8.34408 12.3709 8.73461 11.9804L13.3179 7.39711C13.7094 7.00561 14.3449 7.00713 14.735 7.40001V7.40001Z",
    fill: "#7C63A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationHilightLeft);
export default __webpack_public_path__ + "static/media/paginationHilight-left.50fa192204b2368c50b3dd54f15c70a7.svg";
export { ForwardRef as ReactComponent };